import { isJsonString } from "@finbackoffice/fe-core";
import { createContext, FC, ReactNode, useCallback, useMemo } from "react";

export enum BrowserStorageIdsEnum {
    FAVORITE_EVENTS = "favoriteEvents",
    FAVORITE_LIVE_MARKETS_IDS = "favoriteLiveMarketsIds",
    FAVORITE_PREMATCH_MARKETS_IDS = "favoritePrematchMarketsIds",
    BET_ITEMS = "betItems",
    ODD_FORMAT = "oddFormat",
    WALLET = "wallet",
    DEVICE_ID = "deviceId",
    TOKEN = "token",
    SITE_NOTIFICATIONS = "siteNotifications",
    POPUP_BANNERS = "popupBanners",
    REELS = "reels",
    AFF_CLICK = "affclick",
    AFF_ID = "affid",
    BTAG = "btag",
    UTM_CAMPAIGN = "utm_campaign",
    PREMATCH_TOURNAMENTS = "prematch_tournaments",
    LIVE_MULTI_VIEW = "live_multi_view",
}

type Key = (typeof BrowserStorageIdsEnum)[keyof typeof BrowserStorageIdsEnum];

export type IBrowserStorageContext = {
    set: (key: Key, val: string) => void;
    get: (key: Key) => any | null;
    remove: (key: Key) => void;
};

export const BrowserStorageContext = createContext<IBrowserStorageContext>(null as any);

export const BrowserStorageProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const get = useCallback((key: Key): any | null => {
        if (typeof window !== "undefined") {
            const storage = localStorage.getItem(key);
            if (storage) {
                if (isJsonString(storage)) {
                    return JSON.parse(storage);
                } else {
                    return storage;
                }
            }
        }

        return null;
    }, []);

    const set = useCallback((key: Key, val: string) => {
        localStorage.setItem(key, val);
    }, []);

    const remove = useCallback((key: Key) => {
        localStorage.removeItem(key);
    }, []);

    const value = useMemo(() => ({ get, set, remove }), [get, set, remove]);
    return (
        <BrowserStorageContext.Provider value={value}>{children}</BrowserStorageContext.Provider>
    );
};
